import { EntityDataStore } from '@skinsoft/entity-data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { Featured, FeaturedCard } from '../featured-card';

@Component({
    components: {
        sFeaturedCard: FeaturedCard,
    },
    props: ['entityDataStore', 'id', 'serializer'],
    template: require('./entity-featured-card.html'),
})
export class EntityFeaturedCard<T> extends ReactiveVue {
    public featured: Featured | null = null;
    public entityDataStore: EntityDataStore;
    public serializer: (entity: T) => Observable<Featured>;

    public id: string;

    public created() {
        if (this.id) {
            this.subscribe();
        }
    }

    private subscribe() {
        this.subscribeTo(
            this.entityDataStore.fetchOne(this.id).pipe(mergeMap(this.serializer)),
            featured => {
                this.featured = featured;
            },
            'featured',
        );
    }

    private unsubscribe() {
        this.unsubscribeFrom('featured');
    }

    @Watch('entityDataStore')
    private onEntityDataStoreChange() {
        this.unsubscribe();
        this.subscribe();
    }

    @Watch('id')
    private onIdChange(id: string) {
        this.unsubscribe();
        this.subscribe();
    }
}
